import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Классическая модель для повседневной носки с тремя пуговицами, отложным воротником, обвязанным резинкой. Высокая плотность хлопчатобумажной ткани пике (от 155гр/м<sup>2</sup> до 200гр/м<sup>2</sup>) позволяет отпечатывать качественные изображения любым способом. Поло держит форму, не линяет и не усаживается при стирке.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`classic_polo_shirt`],
      sizeInfo: `classic_polo_shirt`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
